export default __webpack_public_path__ + "static/media/about-thumb-4-challenge.1b0b936f.jpeg";